<template>
    <div>
        <template v-if="isFiltered">
            Total: <strong>{{ filteredAmount }}</strong> of <strong>{{ totalAmount }}</strong>
        </template>
        <template v-else>
            Total: <strong>{{ totalAmount }}</strong>
        </template>
    </div>
</template>

<script>
  export default {
    props: ['totalAmount', 'filteredAmount', 'isFiltered']
  }
</script>
